angular.module('dealerware.web.data').factory('DealerwareTollModel', function ($http, Model)  {

    var baseEndpoint = '/locations/:location_id/tolls';

    var model = new Model(
        {
            baseEndpoint: baseEndpoint
        });


    angular.extend(model.prototype, {});

    return model;
});
